<template>
    <div class="block">
        <div class="row mt-3">
            <div class="col-6 col-lg-4 name_input">
                <input v-model="localFilters.q" class="form-control name_input"
                    placeholder="Vyhledat podle názvu nebo IČO">
            </div>
            <div class="col-6 col-lg-4">
                <VueMultiselect v-model="localFilters.user_in_contact" :options="filteredUsers" label="name"
                    :searchable="true" :multiple="true" placeholder="Uživatelé" class="w-100 multiselect" track-by="id"
                    :select-label="$t('multiselect.pressToSelect')" :deselect-label="$t('multiselect.pressToDeselect')"
                    :selected-label="$t('multiselect.selected')" :limit="3" :limit-text="getLimitText"
                    :showNoResults="false">
                </VueMultiselect>
            </div>
            <!-- Clear filters -->
            <div v-if="showClearFilters()">
                <button class="btn clear_filters" @click="clearFilters()">{{ $t('utils.clearFilters') }}</button>
            </div>
        </div>
        <div class="table_container table-responsive mt-3">
            <table class="table table-hover">
                <thead class="table_head">
                    <tr>
                        <th class="col-3">{{ $t("institution.contacts.name") }}</th>
                        <th class="col-1">{{ $t("institution.contacts.phone") }}</th>
                        <th class="col-2">{{ $t("institution.contacts.email") }}</th>
                        <th class="col-2">{{ $t("institution.contacts.web") }}</th>
                        <th class="col-2">{{ $t("institution.contacts.company") }}</th>
                        <th class="col-2">{{ $t("institution.contacts.created_by") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!filteredContacts || filteredContacts.length == 0">
                        <td colspan="6" class="w-100 text-center">
                            <span v-if="filteredContacts.length === 0" class="w-100">
                                {{ $t("company.noContacts") }}
                            </span>
                        </td>
                    </tr>
                    <tr v-for="contact in filteredContacts" :key="contact.id" class="align-middle">
                        <td class="col-3">
                            <span v-if="contact.first_name">{{ contact.first_name }} {{ contact.last_name }}</span>
                            <span v-else>---</span>
                        </td>
                        <td class="col-1">
                            <span v-if="contact.phone">{{ contact.phone }}</span>
                            <span v-else>---</span>
                        </td>
                        <td class="col-2">
                            <span v-if="contact.email">{{ contact.email }}</span>
                            <span v-else>---</span>
                        </td>
                        <td class="col-2">
                            <span v-if="contact.web">
                                <a :href="contact.web" target="_blank" rel="noopener noreferrer" class="contact_link">{{
                                    contact.web }}</a>
                            </span>
                            <span v-else>---</span>
                        </td>
                        <td class="col-2">
                            <router-link :to="{ name: 'company', params: { slug: contact.company.slug } }"
                                class="contact_link">{{ contact.company.name }}</router-link>
                        </td>
                        <td class="col-2">
                            <UserAvatar v-if="contact.created_by" :user="contact.created_by" />
                            <span v-else>---</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row justify-content-between page_counter mx-1">
        <Paginator v-model:page="page" :pages="Math.ceil(totalCount / onPage)" class="col-auto" />
        <div class="col-auto d-flex page_number">
            <select v-model="onPage" class="form-select align-self-center h-100 col-auto" ref="perPageSelect">
                <option v-for="page in perPage" :key="page" :value="page" class="">
                    <span class="">{{ page }}</span>
                </option>
            </select>
            <icon icon="ArrowUp" class="arrow_up_icon my-auto" @click="openSelect"></icon>
        </div>
    </div>
</template>

<script>
import UserAvatar from '../components/CompanyDetail/UserAvatar.vue';
import VueMultiselect from 'vue-multiselect';
import { mapGetters, mapActions } from 'vuex/dist/vuex.cjs.js';
import Paginator from '@/components/Paginator.vue';

export default {
    components: {
        UserAvatar,
        VueMultiselect,
        Paginator
    },
    data() {
        return {
            contacts: [],
            debounce: 700,
            timeout: null,
            institutionId: null,
            page: 1,
            totalCount: 0,
            onPage: 10,
            perPage: [
                1, 5, 10, 20, 50, 100
            ],
        }
    },
    created() {
        this.institutionId = this.$store.getters.selectedInstitution;
        this.getContacts();
    },
    methods: {
        ...mapActions(["updateFilters"]),
        showClearFilters() {
            return (
                (this.filters.q && this.filters.q.trim().length > 0) ||
                (this.filters.user_in_contact && this.filters.user_in_contact.length > 0)
            );
        },
        clearFilters() {
            this.$store.commit("updateFilters", {
                q: "",
                user_in_contact: []
            });
        },
        loadContacts() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                const params = { ...this.filters };
                if (params.user_in_contact && Array.isArray(params.user_in_contact)) {
                    let userIds = [];
                    params.user_in_contact.forEach((element) => {
                        if (element && element.id) {
                            userIds.push(element.id);
                        }
                    });
                    params.created_by = userIds;
                }
                delete params.user_in_contact;

                this.$store.getters.api.get(`/institution/${this.institutionId}/contacts`, {
                    params: {
                        ...params,
                        page: this.page,
                        per_page: this.onPage
                    }
                })
                    .then((response) => {
                        this.contacts = response.data.results;
                        this.totalCount = response.data.count;
                    })
            }, this.debounce);
        },
        getContacts() {
            this.$store.getters.api.get(`/institution/${this.institutionId}/contacts`, { page: this.page })
                .then(response => {
                    this.contacts = response.data.results;
                    this.totalCount = response.data.count;
                })
        },
        getLimitText(count) {
            return this.$t("multiselect.andMore", { count });
        },
    },
    computed: {
        ...mapGetters(["filters"]),
        localFilters: {
            get() {
                return this.filters;
            },
            set(val) {
                this.updateFilters(val);
            },
        },
        filteredUsers() {
            const createdBySet = new Set();
            const createdByUsers = [];
            this.contacts.forEach((contact) => {
                if (
                    contact.created_by &&
                    contact.created_by.id &&
                    !createdBySet.has(contact.created_by.id)
                ) {
                    createdBySet.add(contact.created_by.id);
                    createdByUsers.push(contact.created_by);
                }
            });
            return createdByUsers;
        },
        filteredContacts() {
            const q = (this.localFilters.q || '').toLowerCase().trim();
            const selectedUserIds = (this.localFilters.user_in_contact || []).map(user => user.id);
            return this.contacts.filter(contact => {
                const fullName = ((contact.first_name || '') + ' ' + (contact.last_name || '')).toLowerCase();
                const phone = contact.phone ? contact.phone.toLowerCase() : '';
                const email = contact.email ? contact.email.toLowerCase() : '';
                const web = contact.web ? contact.web.toLowerCase() : '';

                const matchesText = !q || fullName.includes(q) || phone.includes(q) || email.includes(q) || web.includes(q);
                const matchesUser = selectedUserIds.length === 0 || (contact.created_by && selectedUserIds.includes(contact.created_by.id));

                return matchesText && matchesUser;
            });
        }
    },
    watch: {
        filters: {
            handler() {
                this.loadContacts();
            },
            deep: true,
        },
        page() {
            this.loadContacts();
        },
        onPage() {
            this.loadContacts();
        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.name_input {
    border-radius: $radius-pill !important;
    color: $dark-grey;
    height: 50px;

    input:focus {
        padding-left: 25px;
    }
}

.name_input::placeholder {
    color: $black;
    opacity: 0.9;
    font-size: 18px;
    font-weight: 400;
    padding: 8px;
}

::v-deep .multiselect,
::v-deep .multiselect__tags {
    border-radius: $radius-pill !important;
}

.clear_filters {
    color: $accent;
    background-color: transparent;
    font-weight: 700;
    text-decoration: underline;
}
</style>